// Angular
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UntypedFormControl, ReactiveFormsModule } from '@angular/forms';
import { NgClass } from '@angular/common';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatFormField, MatHint } from '@angular/material/input';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/autocomplete';
import { MatButton } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    // tslint:disable-next-line: component-selector
    selector: 'uw-update-status-dialog',
    templateUrl: './update-status-dialog.component.html',
    imports: [NgClass, MatProgressSpinner, MatFormField, MatSelect, ReactiveFormsModule, MatOption, MatHint, MatButton, TranslateModule]
})
export class UpdateStatusDialogComponent implements OnInit {
  selectedStatusForUpdate = new UntypedFormControl('');
  viewLoading = false;
  loadingAfterSubmit = false;
  constructor(
    public dialogRef: MatDialogRef<UpdateStatusDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit() {
    this.viewLoading = true;
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  updateStatus() {
    if (this.selectedStatusForUpdate.value.length === 0) {
      return;
    }
    this.viewLoading = true;
    this.loadingAfterSubmit = true;
    this.dialogRef.close(this.selectedStatusForUpdate.value);
  }
}
